import { render } from "./BaseCard.vue?vue&type=template&id=595a6b5e&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=595a6b5e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ACER\\Desktop\\Vue Course\\Main Course Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595a6b5e"]])

export default __exports__